@if (data) {
    <div class="row dialog-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
        <div class="col-11 left">
            <h4>
                {{ data.header ? (data.header | translate) : ('shared.dialogs.unsaved-changes-title' | translate) }}
            </h4>
        </div>
        <div class="col-1 right">
            @if (data.disableClose) {
                <button (click)="cancel()">
                    <i class="a-icon a-icon--close"></i>
                </button>
            }
        </div>
    </div>
    <div class="row">
        <div class="col-12 mb-2">
            <p>{{ data.text | translate }}</p>
            @if (data.warningText) {
                <p class="warning-text">{{ data.warningText | translate }}</p>
            }
            @if (data.amount) {
                <p>
                    {{ 'control-center.general.amount-selected' | translate }}
                    {{ data.amount }}
                </p>
            }
        </div>
    </div>
    @if (!data.disableClose) {
        <div class="row">
            <div class="col-12">
                <div class="d-flex gap-10">
                    <ceres-button (click)="confirm()" [icon]="'check-mark'">
                        {{ (data.confirmButtonText ? data.confirmButtonText : 'shared.buttons.apply') | translate }}
                    </ceres-button>
                    @if (!data.disableCancleButton) {
                        <ceres-button (click)="cancel()" [icon]="'close'" [style]="'primary'">
                            {{ (data.cancleButtonText ? data.cancleButtonText : 'shared.buttons.cancel') | translate }}
                        </ceres-button>
                    }
                </div>
            </div>
        </div>
    }
}
